
const MESSAGES = Object.freeze({
  CONNECT_SUCCESS: 'Message sent successfully. We will be in touch with you soon!',
});

export default MESSAGES;